import React, { useEffect, useMemo, useState } from 'react';
import { SVGS } from '../../assets';
import { ReactComponent as CrossIcon } from '@zonofi/svg-icons/cross-icon.svg';
import './search-by-criteria.scss';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Popover from '@mui/material/Popover';
import { searchCriterias } from '../../order';

export interface SearchCriteriaItems {
  id: string;
  name: string;
  placeholder: string;
  searchResults: [];
  onSearch: (searchKey: string) => void;
}

interface SearchByCriteriaProps {
  onUpdateSearchParameter: (
    parmamId: string,
    value: string,
    updateSearchValue?: string
  ) => void;
  onSearchCancel: () => void;
  onRemoveSearchKey?: () => void;
  color?: React.CSSProperties['color'];
}

export const SearchByCriteria: React.FC<SearchByCriteriaProps> = ({
  onUpdateSearchParameter,
  onSearchCancel,
  onRemoveSearchKey = () => {},
  color = '' as React.CSSProperties['color'],
}) => {
  const [selectedCriteria, onSelectCriteria] = useState<string>(
    searchCriterias?.[0]?.id
  );
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [searchKey, setSearchKey] = useState<string>('');
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const currentCriteria = useMemo(() => {
    const selected = searchCriterias.find(({ id }) => id === selectedCriteria);
    return selected ?? searchCriterias[0];
  }, [selectedCriteria, searchCriterias]);

  const onChangeCriteria = (id: string) => {
    onSelectCriteria(id);
    setSearchKey('');
    onUpdateSearchParameter(id, '');
    handleClose();
  };

  useEffect(() => {
    if (searchKey?.length === 0) {
      onRemoveSearchKey();
    }
  }, [searchKey]);

  return (
    <div
      className={`search-by-criteria`}
      style={{ ...(color && { color: color }) }}
    >
      <div className="font-regular">{`Search By ${currentCriteria.name}`}</div>
      <div className="search-by-criteria-container">
        <div className="search-by-criteria-search-bar">
          <div
            className="drop-down-arrow"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            {open ? (
              <KeyboardArrowUpIcon fontSize="small" sx={{ color: 'black' }} />
            ) : (
              <KeyboardArrowDownIcon fontSize="small" sx={{ color: 'black' }} />
            )}
          </div>
          <div className="divider" />
          <div className="search-bar">
            <img src={SVGS.SearchIcon} alt="search" />
            <input
              type="text"
              className="search-input font-medium"
              placeholder={currentCriteria.placeholder}
              value={searchKey}
              onChange={(e) => {
                setSearchKey(e.target.value);
                onUpdateSearchParameter(selectedCriteria, e.target.value);
              }}
              autoFocus
            />
            {searchKey && (
              <CrossIcon
                color="#000"
                onClick={() => {
                  setSearchKey('');
                  onRemoveSearchKey();
                }}
                height={16}
                width={16}
                className="cross-icon"
              />
            )}
          </div>
        </div>
        <div
          className="font-medium cancel-text"
          onClick={() => {
            setSearchKey('');
            onSearchCancel?.();
          }}
          style={{ ...(color && { color: color }) }}
        >
          Cancel
        </div>
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableRestoreFocus
      >
        <div className="criteria-dropdown">
          <div className="heading font-regular">Search By</div>
          {searchCriterias.map(({ id, name }) => (
            <div
              className="item font-regular"
              onClick={() => onChangeCriteria(id)}
              key={id}
            >
              {name}
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
};
